<template>
  <div class="p-the-form-step__wrap">
    <ul class="p-the-form-step" :class="{ 'p-the-form-step--admin': isAdmin }">
      <li
        v-for="(option, key) in options"
        class="p-the-form-step__item"
        :class="{
          'p-the-form-step__over': option.step < step,
          'p-the-form-step__current': option.step === step,
          'p-the-form-step__yet': option.step > step
        }"
        :key="key"
      >
        <i
          class="p-the-form-step__line"
          :style="{ backgroundColor: option.step <= step ? colorCode : '' }"
        ></i>
        <span class="p-the-form-step__item__text">{{ option.label }}</span>
        <IconBase
          class="p-the-form-step__item__icon"
          :style="{ color: colorCode }"
          v-if="option.step < step"
          view-box="0 0 24 24"
          width="24"
          height="24"
        >
          <IconStepOver />
        </IconBase>
        <IconBase
          class="p-the-form-step__item__icon"
          :style="{ color: colorCode }"
          v-else-if="option.step === step"
          view-box="0 0 24 24"
          width="24"
          height="24"
        >
          <IconStepCurrent />
        </IconBase>
        <IconBase
          class="p-the-form-step__item__icon"
          v-else-if="option.step > step"
          view-box="0 0 24 24"
          width="24"
          height="24"
        >
          <IconStepYet />
        </IconBase>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import IconBase from "@/common/components/atoms/IconBase.vue";
import IconStepYet from "@/common/components/icons/IconStepYet.vue";
import IconStepOver from "@/common/components/icons/IconStepOver.vue";
import IconStepCurrent from "@/common/components/icons/IconStepCurrent.vue";

import commons from "@/common/store/modules/commons";
import { mapState } from "vuex";

@Options({
  props: {
	step: { type: Number, required: true },
	options: { type: Array, required: true },
	isAdmin: { type: Boolean, required: false }
  },
  components: {
    IconBase,
    IconStepYet,
    IconStepOver,
    IconStepCurrent
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheFormStep extends Vue {
  step!: number;
  options!: any;
  isAdmin!: boolean;
}
</script>

<style lang="scss" scoped>
.p-the-form-step {
  margin-left: rem(-72);
  margin-right: rem(-72);
  display: flex;
  justify-content: space-between;

  @include sp {
    margin-left: -6%;
    margin-right: -6%;
  }

  &--admin {
    margin-left: 0;
    margin-right: 0;

    @include sp {
      margin-left: -4%;
      margin-right: -4%;
    }
  }

  &__wrap {
    width: 100%;
    max-width: rem(664);
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }

  &__line {
    position: absolute;
    top: px(11);
    right: 50%;
    width: 100%;
    height: px(4);
    display: block;

    @include sp {
      height: px(2);
    }
  }
  &__item:first-child &__line {
    display: none;
  }

  &__yet &__line {
    height: px(2);
    background: $common-gray500;
  }

  &__over &__item__text,
  &__yet &__item__text {
    color: $common-gray500;
  }
  &__current &__item__text {
    font-weight: bold;
  }

  &__item {
    position: relative;
    width: 100%;
    padding-top: px(48);

    @include sp {
      padding-top: px(32);
    }

    &__text {
      text-align: center;
      display: block;
      font-size: 14px;

      @include sp {
        font-size: rem(12);
        max-width: rem(76);
        margin: auto;
      }
    }

    &__icon {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      width: px(28);
      margin: auto;

      @include sp {
        width: px(14);
      }

      &--over {
        background: $common-white;
      }
      &--yet {
        color: $common-gray500;
      }
    }
  }

  &__over &__item__icon {
    background: $common-white;
  }
  &__yet &__item__icon {
    color: $common-gray500;
  }
}
</style>
